import { getSrcs } from '@helpers/image';
import React from 'react';
import { IconListStyles as S } from './IconList.styles';
const IconList = (props) => {
    return (React.createElement(S.Container, { id: props.anchorId, "data-theme": props.theme },
        React.createElement(S.Inner, null,
            React.createElement(S.TitleArea, null,
                React.createElement(S.Title, null, props.title),
                React.createElement(S.SubTitle, null, props.subtitle)),
            React.createElement(S.IconListing, null, props.items &&
                props.items.map((item) => (React.createElement(S.IconCard, { key: item.id },
                    React.createElement(S.IconCardContent, null,
                        React.createElement(S.IconCardTitle, null, item.title),
                        React.createElement(S.IconCardParagraph, null, item.content)),
                    item.image && (React.createElement(S.IconCardImage, null,
                        React.createElement(S.IconCardImageIcon, { alt: item.image?.altText ?? '', loading: "lazy", role: item.image?.altText ? undefined : 'presentation', src: getSrcs(item.image, 260, 200, 2)[0].split(' ')[0] }))),
                    item.mobileImage && (React.createElement(S.MobileIconCardImage, null,
                        React.createElement(S.IconCardImageIcon, { alt: item.mobileImage?.altText ?? '', loading: "lazy", role: item.mobileImage?.altText ? undefined : 'presentation', src: getSrcs(item.mobileImage, 592, 375, 4)[0].split(' ')[0], srcSet: getSrcs(item.mobileImage, 592, 375, 4).join(',') }))))))))));
};
export default IconList;
